import { PageHeader, Section } from "@/components/site/PageChrome";
import { Linkedin, Twitter, Flag, Rocket, Users } from "lucide-react";


const gallery = [
  "/Media-Library/b4.jpeg",
  "/Media-Library/b1.jpeg",
  "/Media-Library/b21.jpeg",
  "/Media-Library/b11.jpeg",
  "/Media-Library/b12.jpeg",
  "/Media-Library/b26.jpeg",
  "/Media-Library/b7.jpeg",
  "/Media-Library/b25.jpeg",
];


const team = [
  {
    name: "MadhuSudhan",
    role: "Founder & Head of Innovation",
    image: "/Media-Library/founder.jpg",
    linkedin: "https://www.linkedin.com/in/madhusudhan-time2cash/",
    bio: "Founder of DIGISWING Innovation Pvt. Ltd. and the visionary behind Time2Cash, leading product innovation, strategy, and the mission of building India's trusted hyperlocal community platform.",
  },
  {
    name: "Manoj Kumar",
    role: "Co-Founder & Innovation Head",
    image: "/Media-Library/co-founder.jpeg",
    linkedin: "https://www.linkedin.com/in/manoj-kumar-p-8137853b5/",
    bio: "Leading innovation initiatives, product improvements, and technology-driven solutions while transforming ideas into practical features for Time2Cash.",
  },
  {
    name: "RamaKrishna",
    role: "Director",
    image: "/Media-Library/director.jpg",
    linkedin: "https://www.linkedin.com/",
    bio: "Overseeing company operations, business strategy, governance, and key organizational decisions to support the long-term growth of DIGISWING and Time2Cash.",
  },
  {
    name: "Revathi",
    role: "Strategy & Business Excellence Advisor",
    image: "/Media-Library/ops.jpeg",
    linkedin: "https://www.linkedin.com/in/revathimedisetti/",
    bio: "Providing strategic guidance, reviewing business plans, offering valuable suggestions, and supporting the team in making informed decisions for sustainable growth.",
  },
];

const milestones = [
  {
    icon: Flag,
    t: "The Idea",
    d: "Time2Cash was born from the need to bring local services, jobs, businesses, and communities together in one platform.",
  },
  {
    icon: Rocket,
    t: "Launching in Anantapur",
    d: "Our first city launch begins in Anantapur with multiple community-focused services.",
  },
  {
    icon: Users,
    t: "Growing Across Cities",
    d: "Our mission is to expand city by city, connecting millions through one trusted local platform.",
  },
];

export default function TeamPage() {
  return (
    <>
      <PageHeader
        eyebrow="Founding Team"
        title="The People Behind Time2Cash"
        subtitle="A passionate team working together to build India's trusted hyperlocal community platform."
      />

      <Section>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {team.map((m) => (
            <div
              key={m.name}
              className="rounded-3xl border border-[#EBE8E3] bg-white p-6 text-center hover:shadow-xl transition-all duration-300"
            >
              <div className="w-28 h-28 mx-auto rounded-full overflow-hidden border-4 border-[#FFF3ED] shadow-lg">
                <img
                  src={m.image}
                  alt={m.name}
                  className="w-full h-full object-cover"
                />
              </div>

              <h3 className="mt-5 text-lg font-bold text-[#1A1918]">
                {m.name}
              </h3>

              <div className="text-sm font-semibold text-[#FF5A00] mt-1">
                {m.role}
              </div>

              <p className="mt-3 text-sm leading-relaxed text-[#4A4846]">
                {m.bio}
              </p>

              <div className="mt-5 flex justify-center gap-3">
                <a
                  href={m.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-[#FFF3ED] flex items-center justify-center hover:bg-[#0A66C2] hover:text-white transition-all"
                  aria-label={`${m.name} LinkedIn`}
                >
                  <Linkedin className="w-4 h-4" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </Section>

      <Section className="bg-[#FFF9F5]">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1A1918]">
          Our Journey So Far
        </h2>

        <div className="mt-10 grid md:grid-cols-3 gap-6">
          {milestones.map(({ icon: Icon, t, d }) => (
            <div
              key={t}
              className="rounded-3xl border border-[#EBE8E3] bg-white p-7 hover:shadow-lg transition-all"
            >
              <div className="w-12 h-12 rounded-2xl bg-[#FFF3ED] flex items-center justify-center">
                <Icon className="w-6 h-6 text-[#FF5A00]" />
              </div>

              <h3 className="mt-4 text-lg font-bold text-[#1A1918]">
                {t}
              </h3>

              <p className="mt-2 text-sm text-[#4A4846] leading-relaxed">
                {d}
              </p>
            </div>
          ))}
        </div>
      </Section>

      <Section>
        <h2 className="text-3xl md:text-4xl font-bold text-[#1A1918]">
          Behind the Scenes
        </h2>

        <p className="mt-2 text-[#4A4846]">
          A glimpse into our journey of building Time2Cash. Photos and videos
          from launches, events, and community activities will be added soon.
        </p>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
  {gallery.map((image, index) => (
    <div
      key={index}
      className="overflow-hidden rounded-2xl border border-[#EBE8E3] shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
    >
      <img
        src={image}
        alt={`Gallery ${index + 1}`}
        className="w-full aspect-square object-cover hover:scale-105 transition-transform duration-500"
      />
    </div>
  ))}
</div>
      </Section>
    </>
  );
}